const matchPreferenceItems = [
  { name: "basicInfo", title: "Basic Information" },
  { name: "bodyPreference", title: "Body Preference" },
  { name: "educationCareer", title: "Education & Career" },
  { name: "idealMatch", title: "Ideal Match Description" },
];

export default matchPreferenceItems;
